import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "                    Master";
const FetchRequestType = "             FetchRequest";

// Save All Data To Database //
export const SaveHotelMiscellaneous = async (ref, payload, images) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, images);
};
// Get All Data From Database //
export const GetHotelMiscellaneousList = async () => {
  let payload = {           Refs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

// Get Single Data From Database //
export const GetHotelMiscellaneous = async (Ref) => {
  let payload = {          Refs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};
